import { ElMessage } from "element-plus";

let messageInstance = null
const resetMessage = (options) => {
    if (messageInstance) messageInstance.close();//判断弹窗是否存在，若存在则关闭
    messageInstance = ElMessage(options)
}

export const message = resetMessage